import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CreditCardService } from '../../../../../shared/cards/credit-card.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemeService } from '../../../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-cards-credit-activation-step3',
	templateUrl: './step3.component.html',
	styleUrls: ['./step3.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CardsCreditActivationStep3Component implements OnInit {

	public img: any;
	public phoneCrCapital = '4004 3500';
	public phoneCrMore = '0800 701 3500';

	constructor(
		private creditCardService: CreditCardService,
		private sanitizer: DomSanitizer,
		private themeService: ThemeService,
	) {}

	ngOnInit(): void {
		this.getImgBannerCreditCard();
		this.definePhonesByTheme();
	}

	definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'www.powerclub.com.br':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				break;
		}
	}

	getImgBannerCreditCard() {
		this.img = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.creditCardService.creditCardImg);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards-activation/credit/activation/step3/step3.component.ts